const availableIntegrations = ['playtech'];

const IntegrationGateway = class IntegrationGateway {
    constructor(name, features, listener) {
        this.name = name;
        this.features = features;
        this.popIntegrationlistener = listener;
    }

    loadIntegration() {
        if (!this.name || !this.features) {
            return;
        }
        if (availableIntegrations.includes(this.name)) {
            this.initializeConnection();
        }
    }

    initializeConnection() {
        this.popIntegrationlistener.setGameConfiguration(this.features)
    }

    pauseGame() {

    }

    sendPauseNotification() {
        this.popIntegrationlistener.pauseGame();
    }

    isGamePaused() {
        return Config.popGracefulPause;
    }

    unpauseGame() {

    }

    startAutoPlay() {
        this.popIntegrationlistener.startAutoplay();
    }

    stopAutoPlay() {
        this.popIntegrationlistener.stopAutoplay();
    }

    interruptAutoPlay() {

    }

    closeGame() {
        this.popIntegrationlistener.closeGameHandler();
    }

    switchMode() {
        this.popIntegrationlistener.sendPlayForRealNotification();
    }
}

export { IntegrationGateway }